const runtimeConfig = window.__APP_CONFIG__ || {};

const runtimeLinks = runtimeConfig.links || {};

export function getRuntimeLink(key, fallback) {
  return runtimeLinks[key] || fallback;
}
